import React, { useState } from "react";
import LabelInput from "../../../Component/labelInput";
import PageTitle from "../../../module/pageTitle";
import { InputField, Submitbtn } from "../../../Component";
import { useDispatch } from "react-redux";
import { AppDispatch } from "../../../store";
import { addTds } from "../publicationSlice";
import { validateFullName, startsWithSpace, validateIsDigitsAndDotOnly } from "../../../Utils/validators";
import { showSnackbar, hideSnackbar } from "../../../store/slices/snackbarSlice";
const CreateTds = () => {
  const dispatch: Function = useDispatch<AppDispatch>();
  const [tdsName, setTdsName] = useState<string>("");
  const [tdsRate, setTdsRate] = useState<string>("");
  const onChangeTDSName = (value: string) => {
    setTdsName(value);
  };
  const onChangeTDSRate = (value: string) => {
    if (validateIsDigitsAndDotOnly(value)) {
      setTdsRate(value)
    }
  };
  const handleSubmit = (e: any) => {
    e.preventDefault();
    const postData = {
      name: tdsName,
      rate: tdsRate
    };
    dispatch(
      addTds({
        params: postData,
        callback: (res: any) => {
          if (res?.status === "success") {
            setTdsRate("");
            setTdsName("");
            dispatch(showSnackbar({ message: res?.msg, type: res?.status }));
            setTimeout(() => {
              hideSnackbar();
            }, 5000);
          }
        },
        errorCallback: (error: any) => { },
      })
    );
  };
  const validations = (): boolean => {
    return tdsName === "" || tdsRate === "";
  };
  return (
    <div className="panel-content">
      <div className="mb-4">
        <PageTitle
          name={"Add TDS"}
          breadCrumb={""}
          isEditMode={""}
          cancelEdit={() => ""}
        />
      </div>
      <div className="formDiv">
        <div className="bxshadow p-2 borderRadius mb-4">
          <form onSubmit={handleSubmit}>
            <div className="row align-items-center">
              <div className="col-md-4 mb-3">
                <LabelInput labelName={"TDS Name"} />
                <InputField
                  key={"ex2"}
                  placeholder={"Enter TDS Name"}
                  setInputText={(value: any) => onChangeTDSName(value)}
                  value={tdsName}
                />
              </div>
              <div className="col-md-4 mb-3">
                <LabelInput labelName={"TDS Rate"} />
                <div className="d-flex align-items-center">
                  <InputField
                    key={"ex2"}
                    placeholder={"Enter TDS Rate"}
                    setInputText={(value: any) => onChangeTDSRate(value)}
                    value={tdsRate}
                  />
                  <span className="fw-bold font18 ms-1">%</span>
                </div>
              </div>
              <div className="col-md-2 mb-3 pt-4">
                <Submitbtn name={"Add TDS"} disabled={validations()} />
              </div>
            </div>
          </form>
        </div>
      </div>
    </div>
  );
};

export default CreateTds;
